import { useState } from 'react';
import Layout from '../../../components/feature/Layout';
import RwaHero from './components/RwaHero';
import RwaComplianceSection from './components/RwaComplianceSection';
import RwaArchitectureSection from './components/RwaArchitectureSection';
import RwaAssetTypesSection from './components/RwaAssetTypesSection';
import RwaIssuanceSection from './components/RwaIssuanceSection';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function RwaPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('compliance');

  const scrollToSection = (id: string) => {
    setActiveTab(id);
    const el = document.getElementById(id);
    if (el) {
      const offset = 140;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <Layout>
      <RwaHero activeTab={activeTab} onTabChange={scrollToSection} />
      <RwaComplianceSection />
      <RwaArchitectureSection />
      <RwaAssetTypesSection />
      <RwaIssuanceSection />

      {/* CTA Footer Band */}
      <section className="bg-dark-bg border-t border-dark-border py-20">
        <div className="max-w-[1400px] mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 bg-amber-500/10 border border-amber-500/20 rounded-full">
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-glow-pulse" />
            <span className="text-amber-400 text-xs font-medium uppercase tracking-widest">{t('productsCta.rwa.tag')}</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-4">
            {t('productsCta.rwa.title')}
          </h2>
          <p className="text-slate-400 text-base mb-8 max-w-xl mx-auto">
            {t('productsCta.rwa.desc1')}
            {t('productsCta.rwa.desc2')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-amber-500 text-dark-bg font-semibold text-sm rounded-xl hover:bg-amber-400 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-customer-service-line" />
              {t('productsCta.rwa.quote')}
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-dark-card border border-dark-border text-slate-400 hover:text-white font-medium text-sm rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              {t('productsCta.back')}
            </Link>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            {[
              { icon: 'ri-shield-check-line', label: t('productsCta.rwa.badge.0') },
              { icon: 'ri-code-s-slash-line', label: t('productsCta.rwa.badge.1') },
              { icon: 'ri-global-line', label: t('productsCta.rwa.badge.2') },
              { icon: 'ri-file-list-3-line', label: t('productsCta.rwa.badge.3') },
            ].map((b, i) => (
              <div key={i} className="flex items-center gap-2 text-slate-500 text-xs">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${b.icon} text-amber-400 text-sm`} />
                </div>
                {b.label}
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
